<template>
  <div class="users">
    <Loading v-if="loading" />
    <Title :title="$t('users')" />
    <div class="users__header">
      <div class="users__header-buttons">
        <div
          :class="{
            container: true,
            tootip: !user?.role.permissions.user.create
          }"
        >
          <!-- <Button
            class="add-button"
            :variant="
              user?.role.permissions.user.create ? 'filled' : 'disabled'
            "
            :title="$t('addUser')"
            @click="addUser"
          /> -->
          <Button
            class="add-button"
            :variant="
              user?.role.permissions.user.create ? 'filled' : 'disabled'
            "
            :title="$t('createUser')"
            @click="createUser"
          />
          <span v-if="!user?.role.permissions.user.create" class="tooltiptext">
            {{ $t('enoughPermissions') }}
          </span>
        </div>
        <div
          :class="{
            container: true,
            tootip: !user?.role.permissions.login_logs.read
          }"
        >
          <Button
            class="loginInfo-button"
            :variant="
              user?.role.permissions.login_logs.read ? 'bordered' : 'disabled'
            "
            :title="$t('loginInformation')"
            @click="loginInformation"
          />
          <span
            v-if="!user?.role.permissions.login_logs.read"
            class="tooltiptext"
          >
            {{ $t('enoughPermissions') }}
          </span>
        </div>
      </div>
    </div>
    <Table :data="users" :columns="columns" @go-to-item="infoUser" />
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';
import router from '@/router';

import { columns } from './configs';

import { Params } from '@/store/modules/users/types';

@Options({
  name: 'Users',
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      lastKey: null,
      userPharmacyId: '',
      params: null,
      columns: columns(this.$t)
    };
  },
  created() {
    this.userPharmacyId = this.user?.pharmacyId;

    if (this.userPharmacyId) {
      this.show();
    }
  },
  unmounted() {
    this.clearUsers();
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapState('users', ['users'])
  },
  methods: {
    ...mapActions('users', ['showUsers', 'clearUsers']),
    async show(params: Params) {
      this.userPharmacyId = this.user?.pharmacyId;

      this.loading = true;
      let defaultParams = {
        lastKey: this.lastKey,
        pageSize: 30,
        pharmacyId: this.userPharmacyId
      };

      if (params) {
        defaultParams = {
          ...defaultParams,
          ...(params.lastKey !== undefined && { lastKey: params.lastKey }),
          ...(params.pageSize !== undefined && { pageSize: params.pageSize }),
          ...(params.pharmacyId !== undefined && {
            pharmacyId: params.pharmacyId
          })
        };
      }

      await this.showUsers(defaultParams);
      this.loading = false;
    },
    createUser() {
      if (this.user?.role.permissions.user.create) {
        router.push({ name: 'CreateUser' });
      }
    },
    addUser() {
      if (this.user?.role.permissions.user.create) {
        router.push({ name: 'AddUser' });
      }
    },
    loginInformation() {
      if (this.user?.role.permissions.login_logs.read) {
        router.push({
          name: 'LoginInformation',
          params: { id: this.user.pharmacyId }
        });
      }
    },
    infoUser(id: string) {
      if (id == this.user.id) {
        router.push({ name: 'Profile' });
      } else {
        router.push({ name: 'InfoUser', params: { id } });
      }
    }
  },
  watch: {
    user() {
      if (this.user) {
        this.userPharmacyId = this.user.pharmacyId;
        this.show();
      }
    }
  }
})
export default class Users extends Vue {}
</script>

<style lang="scss" scoped>
.users {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
  padding: 24px;
  .users__header {
    padding: 24px 0;
    .users__header-buttons {
      display: flex;
      .container {
        .add-button {
          width: 150px;
          margin-right: 10px;
        }
        .loginInfo-button {
          width: 190px;
        }
      }
      .tootip {
        position: relative;
        .tooltiptext {
          position: absolute;
          top: -30%;
          left: 47%;
          transform: translate(-50%, -100%);
          visibility: hidden;
          width: 150px;
          font-size: $elevenSize;
          line-height: $elevenSize;
          background: $label;
          color: $white;
          text-align: center;
          border-radius: 6px;
          padding: 5px;
          z-index: 1;
          opacity: 0;
          transition: opacity 0.3s;
          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: $label transparent transparent transparent;
          }
        }

        &:hover .tooltiptext {
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
}
</style>
